export const DAY_OR_NIGHT = [
  { ID: 1, type: 'Day', value: 1 },
  { ID: 0, type: 'Night', value: 0 },
];
